module.exports = __webpack_public_path__ + "img/评价.dd7493fd.png";